// extracted by mini-css-extract-plugin
export default {"container":"PrivacyStatus_container__w+vPK","items":"PrivacyStatus_items__5ub0o"};